<template>
  <div class="q-mx-auto" style="max-width: 1200px">
    <div class="q-pa-md q-gutter-md" v-if="settings">


      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-h5">
            Styles
          </div>
          <div class="text-subtitle2">
            Features
          </div>
          <div>
            <q-toggle v-model="settings.features.progressbar" label="Show progressbar"
                      debounce="500"
            />
          </div>
          <div>
            <q-toggle v-model="settings.features.centered" label="Centered"
                      debounce="500"
            />
          </div>
          <div>
            <q-toggle v-model="settings.features.card" label="Card style form"
                      debounce="500"
            />
          </div>
        </div>
        <div class="col q-pa-md">

        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-subtitle2">
            Screen styles
          </div>
          <div>
            <q-toggle v-model="settings.theme.screen.title_main" label="Show title"
                      debounce="500"
            />
          </div>
          <div>
            <q-toggle v-model="settings.theme.screen.title" label="Show screen name"
                      debounce="500"
            />
          </div>
          <div>
            <q-toggle v-model="settings.theme.screen.text" label="Show text"
                      debounce="500"
            />
          </div>
        </div>
        <div class="col q-pa-md">
          <h5 v-if="settings.theme.screen.title_main" class="text-h5 q-ma-none q-pa-md mw-form-v2-screen-title mw-form-v2-screen-title-main">Screen title</h5>
          <h5 v-if="settings.theme.screen.title" class="q-ma-none q-pa-md q-py-sm mw-form-v2-screen-title">Screen name</h5>
          <div v-if="settings.theme.screen.text" class="q-ma-none q-pa-md q-py-sm text-body2 mw-form-v2-screen-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div>
        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-subtitle2">
            Input styles
            <q-btn class="q-ml-md" dense size="xs" target="_blank" href="https://quasar.dev/vue-components/input" label="To Docs" outline color="purple" />
          </div>
          <q-toggle v-model="settings.theme.input.label" label="Show labels on top"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.sublabel" label="Show sublabels"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.description" label="Show description"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.filled" label="filled"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.outlined" label="outlined"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.standout" label="standout"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.borderless" label="borderless"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.rounded" label="rounded"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.square" label="square"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.input.dense" label="Use less space (dense)"
                    debounce="500"
          />
          <div class="text-subtitle2">Theme</div>
          <q-toggle v-model="settings.theme.dark" label="Use dark mode"
                    debounce="500"
          />
        </div>
        <div class="col q-pa-md q-gutter-md">
          <div>
          <div v-if="settings.theme.input.label" class="text-body2 mw-form-v2-label-padding">Label</div>
          <q-input
              :filled="settings.theme.input.filled"
              :outlined="settings.theme.input.outlined"
              :standout="settings.theme.input.standout"
              :borderless="settings.theme.input.borderless"
              :rounded="settings.theme.input.rounded"
              :square="settings.theme.input.square"
              :dense="settings.theme.input.dense"
              label="Text input"
          />
          <div v-if="settings.theme.input.description" class="text-caption mw-form-v2-description">description</div>
          </div>
          <div>
          <div  v-if="settings.theme.input.sublabel" class="text-body2 mw-form-v2-label">Sublabel</div>
          <q-option-group
              :options="[{value: 0, label: 'item 1'}, {value: 1, label: 'item 2'}]"
              type="checkbox"
              debounce="500"
              v-model="checkItem"
          />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-subtitle2">
            Button styles
            <q-btn class="q-ml-md" dense size="xs" target="_blank" href="https://quasar.dev/vue-components/button" label="To Docs" outline color="purple" />
          </div>
          <q-toggle v-model="settings.theme.button.flat" label="flat"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.button.rounded" label="rounded"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.button.round" label="round"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.button.outline" label="outline"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.button.push" label="push"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.button.unelevated" label="unelevated"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.button.noCaps" label="noCaps"
                    debounce="500"
          />
          <q-toggle v-model="settings.theme.button.glossy" label="glossy"
                    debounce="500"
          />

          <q-select v-model="this.settings.theme.button.size" filled
                    :options="[ 'xs', 'sm', 'md', 'lg', 'xl' ]"
                    debounce="500"
                    label="Size" dense
          />

        </div>
        <div class="col q-pa-md">
          <div class="q-gutter-md q-mb-md">
          <q-btn
              :flat="!settings.theme.button.cs ? settings.theme.button.flat: null"
              :rounded="!settings.theme.button.cs ? settings.theme.button.rounded: null"
              :round="!settings.theme.button.cs ? settings.theme.button.round: null"
              :outline="!settings.theme.button.cs ? settings.theme.button.outline: null"
              :push="!settings.theme.button.cs ? settings.theme.button.push: null"
              :unelevated="!settings.theme.button.cs ? settings.theme.button.unelevated: true"
              :noCaps="!settings.theme.button.cs ? settings.theme.button.noCaps: null"
              :glossy="!settings.theme.button.cs ? settings.theme.button.glossy : null"
              :size="settings.theme.button.size"
              class="mw-form-v2-btn"
              label="Button primary"
              color="primary"
              :class="{'mw-form-v2-btn-cs':  settings.theme.button.cs}"
              />
          <q-btn
              :flat="!settings.theme.button.cs ? settings.theme.button.flat: null"
              :rounded="!settings.theme.button.cs ? settings.theme.button.rounded: null"
              :round="!settings.theme.button.cs ? settings.theme.button.round: null"
              :outline="!settings.theme.button.cs ? settings.theme.button.outline: null"
              :push="!settings.theme.button.cs ? settings.theme.button.push: null"
              :unelevated="!settings.theme.button.cs ? settings.theme.button.unelevated: true"
              :noCaps="!settings.theme.button.cs ? settings.theme.button.noCaps: null"
              :glossy="!settings.theme.button.cs ? settings.theme.button.glossy : null"
              :size="settings.theme.button.size"
              class="mw-form-v2-btn"
              label="Button secondary"
              :color="settings.theme.button.cs && settings.theme.button.colors.active ? 'primary' : 'secondary'"
              :class="{'mw-form-v2-btn-cs':  settings.theme.button.cs, 'mw-form-v2-btn-cs-active':  settings.theme.button.cs}"
          />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-subtitle2">
            Select, classic & yes/no buttons
          </div>
          <q-toggle v-model="settings.theme.button.cs" label="Enable custom style"
                    debounce="500"
          />
          <template v-if="settings.theme.button.cs">
            <q-input
                filled
                v-model="settings.theme.button.colors.primary"
                label="Classic button bg" dense
                debounce="500"
            >
              <template v-slot:append>
                <q-icon name="s_colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="settings.theme.button.colors.primary" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <q-input
                filled
                v-model="settings.theme.button.colors.border"
                label="Classic button border" dense
                debounce="500"
            >
              <template v-slot:append>
                <q-icon name="s_colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="settings.theme.button.colors.border" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <q-input
                filled
                v-model="settings.theme.button.colors.hover"
                label="Classic button hover bg" dense
                debounce="500"
            >
              <template v-slot:append>
                <q-icon name="s_colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="settings.theme.button.colors.hover" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <q-input
                filled
                v-model="settings.theme.button.colors.hover_border"
                label="Classic button hover border" dense
                debounce="500"
            >
              <template v-slot:append>
                <q-icon name="s_colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="settings.theme.button.colors.hover_border" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <q-input
                filled
                v-model="settings.theme.button.colors.text"
                label="Classic button text color" dense
                debounce="500"
            >
              <template v-slot:append>
                <q-icon name="s_colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="settings.theme.button.colors.text" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <q-input
                filled
                v-model="settings.theme.button.colors.text_hover"
                label="Classic button hover text color" dense
                debounce="500"
            >
              <template v-slot:append>
                <q-icon name="s_colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="settings.theme.button.colors.text_hover" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>

            <q-input
                filled
                v-model="settings.theme.button.colors.active"
                label="Classic button active bg color" dense
                debounce="500"
            >
              <template v-slot:append>
                <q-icon name="s_colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="settings.theme.button.colors.active" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </template>
        </div>
        <div class="col q-pa-md q-gutter-md">

        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-subtitle2">
            Next button style
          </div>
          <q-toggle v-model="settings.theme.next.cs" label="Enable custom style"
                    debounce="500"
          />
          <template v-if="settings.theme.next.cs">
          <q-select v-model="this.settings.theme.next.size" filled
                    :options="[ 'xs', 'sm', 'md', 'lg', 'xl' ]"
                    debounce="500"
                    label="Size" dense
          />
          <q-input
              filled
              v-model="settings.theme.next.colors.primary"
              label="Next button bg" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.next.colors.primary" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.next.colors.border"
              label="Next button border" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.next.colors.border" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.next.colors.hover"
              label="Next button hover bg" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.next.colors.hover" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.next.colors.hover_border"
              label="Next button hover border" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.next.colors.hover_border" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.next.colors.text"
              label="Next button text color" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.next.colors.text" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.next.colors.text_hover"
              label="Next button hover text color" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.next.colors.text_hover" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          </template>
        </div>
        <div class="col q-pa-md q-gutter-md">
          <div  class="q-gutter-md q-mb-md">
            <q-btn
                :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
                :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.next.cs ? settings.theme.button.round: null"
                :outline="!settings.theme.next.cs ? settings.theme.button.outline: null"
                :push="!settings.theme.next.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
                :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"
                label="Next"
                color="primary"
                class="mw-form-v2-btn-next"
                :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-subtitle2">
            Back button style
          </div>
          <q-toggle v-model="settings.theme.back.cs" label="Enable custom style"
                    debounce="500"
          />
          <template v-if="settings.theme.back.cs">
          <q-select v-model="this.settings.theme.back.size" filled
                    :options="[ 'xs', 'sm', 'md', 'lg', 'xl' ]"
                    debounce="500"
                    label="Size" dense
          />
          <q-input
              filled
              v-model="settings.theme.back.colors.primary"
              label="Back button bg" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.back.colors.primary" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.back.colors.border"
              label="Back button border" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.back.colors.border" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.back.colors.hover"
              label="Back button hover bg" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.back.colors.hover" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.back.colors.hover_border"
              label="Back button hover border" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.back.colors.hover_border" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.back.colors.text"
              label="Back button text color" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.back.colors.text" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.back.colors.text_hover"
              label="Back button hover text color" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.back.colors.text_hover" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          </template>
        </div>
        <div class="col q-pa-md q-gutter-md">
          <div  class="q-gutter-md q-mb-md">
            <q-btn
                :flat="!settings.theme.back.cs ? true: null"
                :rounded="!settings.theme.back.cs ? settings.theme.button.rounded: null"
                :round="!settings.theme.back.cs ? settings.theme.button.round: null"
                :outline="!settings.theme.back.cs ? settings.theme.button.outline: null"
                :push="!settings.theme.back.cs ? settings.theme.button.push: null"
                :unelevated="!settings.theme.back.cs ? settings.theme.button.unelevated: true"
                :noCaps="!settings.theme.back.cs ? settings.theme.button.noCaps: null"
                :glossy="!settings.theme.back.cs ? settings.theme.button.glossy: null"
                :size="settings.theme.back.cs ? settings.theme.back.size: settings.theme.button.size"
                label="Back"
                color="primary"
                class="mw-form-v2-btn-back"
                :class="{'mw-form-v2-btn-back-cs':  settings.theme.back.cs}"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-subtitle2">
            Colors
            <q-btn class="q-ml-md" dense size="xs" target="_blank" href="https://quasar.dev/style/color-palette" label="To Docs" outline color="purple" />
          </div>
          <q-input
              filled
              v-model="settings.theme.colors.primary"
              label="Primary color" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.colors.primary" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.colors.secondary"
              label="Secondary color" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.colors.secondary" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.colors.dark"
              label="Dark color" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.colors.dark" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input
              filled
              v-model="settings.theme.colors.darkPage"
              label="darkPage color" dense
              debounce="500"
          >
            <template v-slot:append>
              <q-icon name="s_colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="settings.theme.colors.darkPage" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>

        </div>
        <div class="col q-pa-md q-gutter-md">
          <div class="text-subtitle2">
            Css color vars. Please use them in css classes. Sample "color:var(--q-primary)"
          </div>
            <div class="brand-color text-center row inline flex-center text-white rounded-borders bg-primary"
                 >
              <div class="col q-pa-sm" >--q-primary</div>
            </div>
            <div class="brand-color text-center row inline flex-center text-white rounded-borders bg-secondary"
                 >
              <div class="col q-pa-sm" >--q-secondary</div>
            </div>
            <div class="brand-color text-center row inline flex-center text-white rounded-borders bg-accent"
                 >
              <div class="col q-pa-sm" >--q-accent</div>
            </div>
            <div class="brand-color text-center row inline flex-center text-white rounded-borders bg-dark"
                 >
              <div class="col q-pa-sm" >--q-dark</div>
            </div>
          <div class="brand-color text-center row inline flex-center text-white rounded-borders" style="color:#fff;background-color: var(--q-dark-page)"
          >
            <div class="col q-pa-sm" >--q-dark-page</div>
          </div>
            <div class="brand-color text-center row inline flex-center text-white rounded-borders bg-positive"
                 >
              <div class="col q-pa-sm" >--q-positive</div>
            </div>
            <div class="brand-color text-center row inline flex-center text-white rounded-borders bg-negative"
                 >
              <div class="col q-pa-sm" >--q-negative</div>
            </div>
            <div class="brand-color text-center row inline flex-center text-white rounded-borders bg-info"
                 >
              <div class="col q-pa-sm" >--q-info</div>
            </div>
            <div class="brand-color text-center row inline flex-center text-white rounded-borders bg-warning"
                 >
              <div class="col q-pa-sm" >--q-warning</div>
            </div>

        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">

          <div class="text-subtitle2">
            Css classes
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-btn-gutter"></q-badge>
            <span>Space gutter for buttons</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-label"></q-badge>
            <span>Label & sublabel</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-label-padding"></q-badge>
            <span>Label & sublabel padding. Used on custom fields where there are no gutter applied</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-description"></q-badge>
            <span>Description</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-linear-progress"></q-badge>
            <span>Progress</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-linear-progress-badge"></q-badge>
            <span>Progress badge</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-linear-slider"></q-badge>
            <span>Slider</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-linear-slider-label-badge"></q-badge>
            <span>Slider label badge</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-input"></q-badge>
            <span>Input</span>
          </div>
          <div class="text-body2">
            <q-badge color="info" class="q-mr-md" label="mw-form-v2-select"></q-badge>
            <span>Select</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col q-gutter-md">
          <div class="text-subtitle2">
            Hidden fields
          </div>

          <q-list bordered class="rounded-borders" style="max-width: 600px">

            <q-item

            v-for="(field, field_index) in settings.hidden_fields"
            :key="field_index"
            >
              <q-item-section top class="col gt-sm">
                <q-item-label class="q-mt-sm">{{field_index}}</q-item-label>
              </q-item-section>

              <q-item-section top class="col gt-sm">
                <q-item-label class="q-mt-sm">{{field}}</q-item-label>
              </q-item-section>
              <q-item-section top side class="col-2 gt-sm">
                <div class="text-grey-8 q-gutter-xs">
                  <q-btn @click="deleteHiddenField(field_index)" class="gt-xs" size="12px" flat dense round icon="s_delete" />
                </div>
              </q-item-section>
            </q-item>
            <q-item>
              <q-item-section top class="col gt-sm">
                <q-input
                    filled
                    label="Field name" dense
                    debounce="500"
                    v-model="hiddenFieldName"
                ></q-input>
              </q-item-section>
              <q-item-section top class="col gt-sm">
                <q-input
                    filled
                    label="Value" dense
                    debounce="500"
                    v-model="hiddenFieldValue"
                ></q-input>
              </q-item-section>
              <q-item-section top side class="col gt-sm">
                <q-btn @click="addHiddenField" color="white" text-color="black" label="Add field" icon="s_add_circle" />
              </q-item-section>
            </q-item>
          </q-list>
        </div>
      </div>
      <q-input
          outlined
          v-model="jsonSettings"
          label="Json settings"
          lazy-rules
          debounce="500"
          autogrow
          disable
      />
      <q-btn
          label="Reset defaults" @click="reset()"
          color="primary"
      ></q-btn>

    </div>
  </div>
</template>

<script>


import {colors, Dark, setCssVar} from "quasar";
import deepmerge from "deepmerge";
import {defaultSettings} from "@/helpers/default";

export default {
  data() {
    return {
      featureProgressbar: false,
      // dark: false,
      // buttonSize: "md",
      // color_primary: "#027BE3",
      // color_secondary: "#26A69A",
      // color_dark: "#1d1d1d",
      // color_darkPage: "#121212",
      checkItem: [],
      jsonSettings : "",
      default : defaultSettings,
      settings : null,
      hiddenFieldName: null,
      hiddenFieldValue: null
    };
  },
  components: {

  },
  methods: {
    reset () {
      this.settings = JSON.parse(JSON.stringify(this.default));
      // this.dark = this.settings.theme.dark;
      // this.color_primary = this.settings.theme.colors.primary;
      // this.color_secondary = this.settings.theme.colors.secondary;
      // this.color_dark = this.settings.theme.colors.dark;
      // this.color_darkPage = this.settings.theme.colors.darkPage;
      // this.buttonSize = this.settings.theme.button.size;
    },
    updateJson() {
      this.jsonSettings = JSON.stringify(this.settings);
      const urlParams = new URLSearchParams(window.location.search);
      const parentId = urlParams.get('parent');
      if(window.parent) {
        try {
          const item = window.parent.document.getElementById(parentId);
          if(item) {
            item.value = this.jsonSettings;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    addHiddenField() {
      this.settings.hidden_fields[this.hiddenFieldName] = this.hiddenFieldValue;
      this.hiddenFieldName = null;
      this.hiddenFieldValue = null;
    },
    deleteHiddenField(hiddenFieldName) {
      delete this.settings.hidden_fields[hiddenFieldName];
    }
  },
  computed: {

  },
  mounted() {

    if(window.parent) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const parentId = urlParams.get('parent');
        const item = window.parent.document.getElementById(parentId);
        if(item) {
          this.settings = deepmerge(this.default, JSON.parse(item.value));
        }
      } catch (e) {
        console.log(e);
      }
    }

    if(!this.settings) {
      this.settings = JSON.parse(JSON.stringify(this.default));
    }

    // this.dark = this.settings.theme.dark;
    // this.color_primary = this.settings.theme.colors.primary;
    // this.color_secondary = this.settings.theme.colors.secondary;
    // this.color_dark = this.settings.theme.colors.dark;
    // this.color_darkPage = this.settings.theme.colors.darkPage;
    // this.buttonSize = this.settings.theme.button.size;
    this.updateJson();
  },
  watch: {
    settings: {
      handler() {
        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
        Dark.set(this.settings.theme.dark);
        const { lighten } = colors;
        setCssVar('primary', this.settings.theme.colors.primary);
        setCssVar('primary-darkened', lighten(this.settings.theme.colors.primary, -10));
        setCssVar('secondary', this.settings.theme.colors.secondary);
        setCssVar('secondary-darkened', lighten(this.settings.theme.colors.secondary, -10));
        setCssVar('dark', this.settings.theme.colors.dark);
        setCssVar('dark-page', this.settings.theme.colors.darkPage);

        if(this.settings.theme.next.colors.primary) {
          setCssVar('fb-next-colors-primary', this.settings.theme.next.colors.primary);
        }
        if(this.settings.theme.next.colors.border) {
          setCssVar('fb-next-colors-border', this.settings.theme.next.colors.border);
        }
        if(this.settings.theme.next.colors.hover) {
          setCssVar('fb-next-colors-hover', this.settings.theme.next.colors.hover);
        }
        if(this.settings.theme.next.colors.hover_border) {
          setCssVar('fb-next-colors-hover_border', this.settings.theme.next.colors.hover_border);
        }
        if(this.settings.theme.next.colors.text) {
          setCssVar('fb-next-colors-text', this.settings.theme.next.colors.text);
        }
        if(this.settings.theme.next.colors.text_hover) {
          setCssVar('fb-next-colors-text_hover', this.settings.theme.next.colors.text_hover);
        }

        if(this.settings.theme.back.colors.primary) {
          setCssVar('fb-back-colors-primary', this.settings.theme.back.colors.primary);
        }
        if(this.settings.theme.back.colors.border) {
          setCssVar('fb-back-colors-border', this.settings.theme.back.colors.border);
        }
        if(this.settings.theme.back.colors.hover) {
          setCssVar('fb-back-colors-hover', this.settings.theme.back.colors.hover);
        }
        if(this.settings.theme.back.colors.hover_border) {
          setCssVar('fb-back-colors-hover_border', this.settings.theme.back.colors.hover_border);
        }
        if(this.settings.theme.back.colors.text) {
          setCssVar('fb-back-colors-text', this.settings.theme.back.colors.text);
        }
        if(this.settings.theme.back.colors.text_hover) {
          setCssVar('fb-back-colors-text_hover', this.settings.theme.back.colors.text_hover);
        }


        if(this.settings.theme.button.colors.primary) {
          setCssVar('fb-button-colors-primary', this.settings.theme.button.colors.primary);
        }
        if(this.settings.theme.button.colors.active) {
          setCssVar('fb-button-colors-active', this.settings.theme.button.colors.active);
        }
        if(this.settings.theme.button.colors.border) {
          setCssVar('fb-button-colors-border', this.settings.theme.button.colors.border);
        }
        if(this.settings.theme.button.colors.hover) {
          setCssVar('fb-button-colors-hover', this.settings.theme.button.colors.hover);
        }
        if(this.settings.theme.button.colors.hover_border) {
          setCssVar('fb-button-colors-hover_border', this.settings.theme.button.colors.hover_border);
        }
        if(this.settings.theme.button.colors.text) {
          setCssVar('fb-button-colors-text', this.settings.theme.button.colors.text);
        }
        if(this.settings.theme.button.colors.text_hover) {
          setCssVar('fb-button-colors-text_hover', this.settings.theme.button.colors.text_hover);
        }
        this.updateJson();
      },
      deep: true
    },
    // dark: function (dark) {
    //   this.settings.theme.dark = dark;
    //   Dark.set(dark);
    //   this.updateJson();
    // },
    // buttonSize: function (size) {
    //   this.settings.theme.button.size = size;
    //   this.updateJson();
    // },
    //
    // featureProgressbar: function (value) {
    //   this.settings.features.progressbar = value;
    //   this.updateJson();
    // },
    // color_primary: function (color) {
    //   const { lighten } = colors;
    //   setCssVar('primary', color);
    //   setCssVar('primary-darkened', lighten(color, -10));
    //   this.settings.theme.colors.primary = this.color_primary;
    //   this.updateJson();
    // },
    // color_secondary: function (color) {
    //   const { lighten } = colors;
    //   setCssVar('secondary', color);
    //   setCssVar('secondary-darkened', lighten(color, -10));
    //   this.settings.theme.colors.secondary = this.color_secondary;
    //   this.updateJson();
    // },
    // color_dark: function (color) {
    //   setCssVar('dark', color);
    //   this.settings.theme.colors.dark = this.color_dark;
    //   this.updateJson();
    // },
    // color_darkPage: function (color) {
    //   setCssVar('dark-page', color);
    //   this.settings.theme.colors.darkPage = this.color_darkPage;
    //   this.updateJson();
    // },
  }
}
</script>
